<template>
  <div class="page-title fix_width">
    <div>
      <h1>{{main}}</h1>
      <p>{{sub}}</p>
    </div>
    <img :src="getImage" />
  </div>
</template>

<script>
export default {
  name: 'page-title',
  props: ['main', 'sub', 'image'],
  computed: {
    getImage () {
      const images = require.context('../assets/', false, /\.png$/)
      return images(`./${this.image}.png`)
    }
  }
}
</script>

<style lang="less" scoped>
.page-title{
  position: relative;
  display: flex;
  justify-content: left;
  align-items: baseline;
  flex-grow: 2;
  text-align: left;
  &>div{margin-top: 5.67em;}
  & *{color: #FFF;}
  h1{
    font-size: 2.28em;
    font-weight: 600;
    margin: 0;
  }
  p{
    font-size: 1em;
    line-height: 2.22;
  }
  img{
    position: absolute;
    width: auto;
    max-width: 62%;
    height: auto;
    bottom: 0;
    right: -5em;
  }
}
@media screen and (min-width: 768px) and (max-width: 1050px) {
  .page-title{
    &>div{margin: 2em 5em 3em;}
    img{
      max-width: 46%;
      right: 1em;
    }
  }
}
@media screen and (max-width: 767.9px) {
  .page-title{
    padding: 0 1em;
    &>div{margin-top: 1em;}
    h1{
      position: relative;
      font-size: 2em;
      top: -.8em;
      z-index: 5;
      text-shadow: 0 .1em .3em rgba(0,0,0,.8);
    }
    p{
      position: relative;
      top: -2.2em;
      z-index: 6;
      text-shadow: 0 .1em .3em rgba(0,0,0,.8);
    }
    img{
      width: 60%;
      height: inherit;
      right: 0;
      filter: contrast(72%);
    }
  }
}
</style>
